export default "__VITE_ASSET__851da6c2__"